import { useState, useEffect } from 'react';
import { API, getAuthHeader } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { 
  MessageSquare, Wifi, WifiOff, QrCode, Key, 
  Check, X, RefreshCw, Send, Settings, AlertCircle,
  Smartphone, Globe, Shield, Clock, ChevronRight, Phone,
  Plus, Trash2, Edit2, Star
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Label } from '../components/ui/label';

export default function WhatsAppConfigPage() {
  var configState = useState(null);
  var config = configState[0];
  var setConfig = configState[1];
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var conectandoState = useState(false);
  var conectando = conectandoState[0];
  var setConectando = conectandoState[1];
  var qrCodeState = useState(null);
  var qrCode = qrCodeState[0];
  var setQrCode = qrCodeState[1];
  
  // Múltiplos canais Z-API
  var canaisState = useState([]);
  var canais = canaisState[0];
  var setCanais = canaisState[1];
  var modalCanalState = useState(false);
  var modalCanal = modalCanalState[0];
  var setModalCanal = modalCanalState[1];
  var editingCanalState = useState(null);
  var editingCanal = editingCanalState[0];
  var setEditingCanal = editingCanalState[1];
  var formCanalState = useState({ nome: '', instance_id: '', token: '', security_token: '', descricao: '' });
  var formCanal = formCanalState[0];
  var setFormCanal = formCanalState[1];
  var salvandoCanalState = useState(false);
  var salvandoCanal = salvandoCanalState[0];
  var setSalvandoCanal = salvandoCanalState[1];
  
  // Form API Oficial
  var apiTokenState = useState('');
  var apiToken = apiTokenState[0];
  var setApiToken = apiTokenState[1];
  var phoneNumberIdState = useState('');
  var phoneNumberId = phoneNumberIdState[0];
  var setPhoneNumberId = phoneNumberIdState[1];
  var businessAccountIdState = useState('');
  var businessAccountId = businessAccountIdState[0];
  var setBusinessAccountId = businessAccountIdState[1];
  
  // Form Twilio
  var twilioAccountSidState = useState('');
  var twilioAccountSid = twilioAccountSidState[0];
  var setTwilioAccountSid = twilioAccountSidState[1];
  var twilioAuthTokenState = useState('');
  var twilioAuthToken = twilioAuthTokenState[0];
  var setTwilioAuthToken = twilioAuthTokenState[1];
  var twilioWhatsappNumberState = useState('');
  var twilioWhatsappNumber = twilioWhatsappNumberState[0];
  var setTwilioWhatsappNumber = twilioWhatsappNumberState[1];
  
  // Form Z-API (legado - para compatibilidade)
  var zapiInstanceIdState = useState('');
  var zapiInstanceId = zapiInstanceIdState[0];
  var setZapiInstanceId = zapiInstanceIdState[1];
  var zapiTokenState = useState('');
  var zapiToken = zapiTokenState[0];
  var setZapiToken = zapiTokenState[1];
  var zapiSecurityTokenState = useState('');
  var zapiSecurityToken = zapiSecurityTokenState[0];
  var setZapiSecurityToken = zapiSecurityTokenState[1];
  
  // Teste de envio
  var telefoneTesteState = useState('');
  var telefoneTeste = telefoneTesteState[0];
  var setTelefoneTeste = telefoneTesteState[1];
  var mensagemTesteState = useState('Olá! Esta é uma mensagem de teste da HOME ON.');
  var mensagemTeste = mensagemTesteState[0];
  var setMensagemTeste = mensagemTesteState[1];
  
  var user = JSON.parse(localStorage.getItem('user') || '{}');
  var isSuperAdmin = user.is_super_admin === true;

  useEffect(function() {
    loadConfig();
    loadCanais();
    var interval = setInterval(function() {
      loadConfig();
      loadCanais();
      if (config && (config.status === 'conectando' || config.status === 'waiting_qr')) {
        loadQrCode();
      }
    }, 5000);
    return function() { clearInterval(interval); };
  }, []);

  function loadConfig() {
    axios.get(API + '/whatsapp/config', { headers: getAuthHeader() })
      .then(function(res) { 
        setConfig(res.data); 
        setLoading(false);
        if (res.data.status === 'conectando' || res.data.status === 'waiting_qr') {
          loadQrCode();
        }
      })
      .catch(function() { toast.error('Erro ao carregar configuração'); setLoading(false); });
  }
  
  function loadCanais() {
    axios.get(API + '/whatsapp/canais', { headers: getAuthHeader() })
      .then(function(res) {
        setCanais(res.data.canais || []);
      })
      .catch(function() {});
  }
  
  function abrirModalCanal(canal) {
    if (canal) {
      setEditingCanal(canal);
      setFormCanal({
        nome: canal.nome || '',
        instance_id: canal.instance_id || '',
        token: '',
        security_token: '',
        descricao: canal.descricao || ''
      });
    } else {
      setEditingCanal(null);
      setFormCanal({ nome: '', instance_id: '', token: '', security_token: '', descricao: '' });
    }
    setModalCanal(true);
  }
  
  function salvarCanal() {
    if (!formCanal.nome || !formCanal.instance_id || (!editingCanal && !formCanal.token)) {
      toast.error('Preencha os campos obrigatórios');
      return;
    }
    
    setSalvandoCanal(true);
    
    var payload = {
      nome: formCanal.nome,
      instance_id: formCanal.instance_id,
      token: formCanal.token || undefined,
      security_token: formCanal.security_token || undefined,
      descricao: formCanal.descricao
    };
    
    var request;
    if (editingCanal) {
      request = axios.put(API + '/whatsapp/canais/' + editingCanal.id, payload, { headers: getAuthHeader() });
    } else {
      request = axios.post(API + '/whatsapp/canais', payload, { headers: getAuthHeader() });
    }
    
    request
      .then(function() {
        toast.success(editingCanal ? 'Canal atualizado!' : 'Canal adicionado!');
        setModalCanal(false);
        loadCanais();
        loadConfig();
      })
      .catch(function(err) {
        toast.error(err.response?.data?.detail || 'Erro ao salvar canal');
      })
      .finally(function() {
        setSalvandoCanal(false);
      });
  }
  
  function excluirCanal(canal) {
    if (!window.confirm('Deseja excluir o canal "' + canal.nome + '"?')) return;
    
    axios.delete(API + '/whatsapp/canais/' + canal.id, { headers: getAuthHeader() })
      .then(function() {
        toast.success('Canal excluído!');
        loadCanais();
        loadConfig();
      })
      .catch(function(err) {
        toast.error(err.response?.data?.detail || 'Erro ao excluir canal');
      });
  }
  
  function definirPrincipal(canal) {
    axios.put(API + '/whatsapp/canais/' + canal.id + '/principal', {}, { headers: getAuthHeader() })
      .then(function() {
        toast.success('Canal "' + canal.nome + '" definido como principal!');
        loadCanais();
        loadConfig();
      })
      .catch(function(err) {
        toast.error(err.response?.data?.detail || 'Erro ao definir canal principal');
      });
  }

  function loadQrCode() {
    axios.get(API + '/whatsapp/qr', { headers: getAuthHeader() })
      .then(function(res) { 
        if (res.data.qr_code) {
          setQrCode(res.data.qr_code);
        }
      })
      .catch(function() {});
  }

  function selecionarMetodo(metodo) {
    setConectando(true);
    axios.put(API + '/whatsapp/config/metodo?metodo=' + metodo, {}, { headers: getAuthHeader() })
      .then(function() {
        toast.success('Método selecionado: ' + metodo);
        loadConfig();
      })
      .catch(function(err) { toast.error(err.response?.data?.detail || 'Erro'); })
      .finally(function() { setConectando(false); });
  }

  function conectarBaileys() {
    setConectando(true);
    axios.post(API + '/whatsapp/conectar/baileys', {}, { headers: getAuthHeader() })
      .then(function(res) {
        toast.success(res.data.message);
        loadConfig();
      })
      .catch(function(err) { toast.error(err.response?.data?.detail || 'Erro'); })
      .finally(function() { setConectando(false); });
  }

  function conectarApiOficial() {
    if (!apiToken || !phoneNumberId) {
      toast.error('Preencha o Token e Phone Number ID');
      return;
    }
    setConectando(true);
    var params = 'api_token=' + encodeURIComponent(apiToken) + '&phone_number_id=' + encodeURIComponent(phoneNumberId);
    if (businessAccountId) params += '&business_account_id=' + encodeURIComponent(businessAccountId);
    
    axios.post(API + '/whatsapp/conectar/api-oficial?' + params, {}, { headers: getAuthHeader() })
      .then(function(res) {
        toast.success(res.data.message);
        loadConfig();
      })
      .catch(function(err) { toast.error(err.response?.data?.detail || 'Erro'); })
      .finally(function() { setConectando(false); });
  }

  function conectarTwilio() {
    if (!twilioAccountSid || !twilioAuthToken || !twilioWhatsappNumber) {
      toast.error('Preencha todos os campos da Twilio');
      return;
    }
    setConectando(true);
    var params = 'account_sid=' + encodeURIComponent(twilioAccountSid) + 
                 '&auth_token=' + encodeURIComponent(twilioAuthToken) + 
                 '&whatsapp_number=' + encodeURIComponent(twilioWhatsappNumber);
    
    axios.post(API + '/whatsapp/conectar/twilio?' + params, {}, { headers: getAuthHeader() })
      .then(function(res) {
        toast.success(res.data.message);
        loadConfig();
      })
      .catch(function(err) { toast.error(err.response?.data?.detail || 'Erro ao conectar Twilio'); })
      .finally(function() { setConectando(false); });
  }

  function conectarZapi() {
    if (!zapiInstanceId || !zapiToken) {
      toast.error('Preencha Instance ID e Token da Z-API');
      return;
    }
    setConectando(true);
    var params = 'instance_id=' + encodeURIComponent(zapiInstanceId) + 
                 '&token=' + encodeURIComponent(zapiToken);
    if (zapiSecurityToken) params += '&security_token=' + encodeURIComponent(zapiSecurityToken);
    
    axios.post(API + '/whatsapp/conectar/zapi?' + params, {}, { headers: getAuthHeader() })
      .then(function(res) {
        toast.success(res.data.message);
        loadConfig();
      })
      .catch(function(err) { toast.error(err.response?.data?.detail || 'Erro ao conectar Z-API'); })
      .finally(function() { setConectando(false); });
  }

  function desconectar() {
    if (!window.confirm('Deseja desconectar o WhatsApp?')) return;
    setConectando(true);
    axios.post(API + '/whatsapp/desconectar', {}, { headers: getAuthHeader() })
      .then(function() {
        toast.success('WhatsApp desconectado');
        loadConfig();
      })
      .catch(function(err) { toast.error(err.response?.data?.detail || 'Erro'); })
      .finally(function() { setConectando(false); });
  }

  function simularConexao() {
    setConectando(true);
    axios.post(API + '/whatsapp/simular-conexao', {}, { headers: getAuthHeader() })
      .then(function() {
        toast.success('Conexão simulada!');
        loadConfig();
      })
      .catch(function(err) { toast.error(err.response?.data?.detail || 'Erro'); })
      .finally(function() { setConectando(false); });
  }

  function enviarTeste() {
    if (!telefoneTeste || !mensagemTeste) {
      toast.error('Preencha telefone e mensagem');
      return;
    }
    axios.post(
      API + '/whatsapp/enviar?telefone=' + encodeURIComponent(telefoneTeste) + '&mensagem=' + encodeURIComponent(mensagemTeste),
      {},
      { headers: getAuthHeader() }
    ).then(function() {
      toast.success('Mensagem enviada!');
    }).catch(function(err) { toast.error(err.response?.data?.detail || 'Erro ao enviar'); });
  }

  function getStatusColor(status) {
    if (status === 'conectado') return 'text-green-500';
    if (status === 'conectando') return 'text-yellow-500';
    if (status === 'erro') return 'text-red-500';
    return 'text-slate-400';
  }

  function getStatusIcon(status) {
    if (status === 'conectado') return <Wifi className="w-5 h-5 text-green-500" />;
    if (status === 'conectando') return <RefreshCw className="w-5 h-5 text-yellow-500 animate-spin" />;
    if (status === 'erro') return <AlertCircle className="w-5 h-5 text-red-500" />;
    return <WifiOff className="w-5 h-5 text-slate-400" />;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="whatsapp-config-page">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
            <MessageSquare className="w-7 h-7 text-green-500" />
            Configuração WhatsApp
          </h1>
          <p className="text-slate-500 text-sm">Conecte sua conta do WhatsApp para atendimento</p>
        </div>
        <div className="flex items-center gap-3">
          {getStatusIcon(config?.status)}
          <span className={'font-medium capitalize ' + getStatusColor(config?.status)}>
            {config?.status || 'Desconectado'}
          </span>
        </div>
      </div>

      {!isSuperAdmin && (
        <Card className="bg-amber-50 border-amber-200">
          <CardContent className="py-4">
            <p className="text-amber-800 text-sm">
              <strong>🔐 Área restrita:</strong> Apenas o Super Admin pode configurar a integração WhatsApp.
            </p>
          </CardContent>
        </Card>
      )}

      {/* Múltiplos Canais Z-API */}
      {isSuperAdmin && (
        <Card>
          <CardHeader className="flex flex-row items-center justify-between">
            <div>
              <CardTitle className="flex items-center gap-2">
                <Smartphone className="w-5 h-5 text-green-500" />
                Canais WhatsApp Z-API
              </CardTitle>
              <p className="text-slate-500 text-sm mt-1">Gerencie até 3 números de WhatsApp conectados</p>
            </div>
            {canais.length < 3 && (
              <Button onClick={function() { abrirModalCanal(null); }} className="bg-green-600 hover:bg-green-700">
                <Plus className="w-4 h-4 mr-2" />
                Adicionar Canal
              </Button>
            )}
          </CardHeader>
          <CardContent>
            {canais.length === 0 ? (
              <div className="text-center py-8">
                <Smartphone className="w-12 h-12 text-slate-300 mx-auto mb-3" />
                <p className="text-slate-500">Nenhum canal configurado</p>
                <Button onClick={function() { abrirModalCanal(null); }} className="mt-3 bg-green-600 hover:bg-green-700">
                  <Plus className="w-4 h-4 mr-2" />
                  Adicionar Primeiro Canal
                </Button>
              </div>
            ) : (
              <div className="space-y-3">
                {canais.map(function(canal) {
                  return (
                    <div key={canal.id} className={'flex items-center justify-between p-4 rounded-lg border ' + (canal.principal ? 'bg-green-50 border-green-200' : 'bg-slate-50 border-slate-200')}>
                      <div className="flex items-center gap-4">
                        <div className={'w-12 h-12 rounded-full flex items-center justify-center ' + (canal.conectado ? 'bg-green-500' : 'bg-slate-400')}>
                          {canal.conectado ? <Wifi className="w-6 h-6 text-white" /> : <WifiOff className="w-6 h-6 text-white" />}
                        </div>
                        <div>
                          <div className="flex items-center gap-2">
                            <p className="font-semibold text-slate-800">{canal.nome}</p>
                            {canal.principal && (
                              <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full flex items-center gap-1">
                                <Star className="w-3 h-3" /> Principal
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-slate-500">
                            {canal.telefone || 'Número não detectado'} • {canal.conectado ? 'Conectado' : 'Desconectado'}
                          </p>
                          <p className="text-xs text-slate-400">Instance: {canal.instance_id}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        {!canal.principal && (
                          <Button variant="outline" size="sm" onClick={function() { definirPrincipal(canal); }} title="Definir como principal">
                            <Star className="w-4 h-4" />
                          </Button>
                        )}
                        <Button variant="outline" size="sm" onClick={function() { abrirModalCanal(canal); }}>
                          <Edit2 className="w-4 h-4" />
                        </Button>
                        <Button variant="outline" size="sm" onClick={function() { excluirCanal(canal); }} className="text-red-500 hover:bg-red-50">
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                  );
                })}
                <p className="text-xs text-slate-400 mt-2">
                  {canais.length}/3 canais configurados. O canal principal é usado para envio de mensagens.
                </p>
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Status Atual */}
      {config?.status === 'conectado' && (
        <Card className="bg-green-50 border-green-200">
          <CardContent className="py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <Check className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="font-semibold text-green-800">WhatsApp Conectado</p>
                  <p className="text-green-600 text-sm">{config.telefone || 'Número não informado'}</p>
                  <p className="text-green-500 text-xs">
                    Método: {config.metodo === 'zapi' ? 'Z-API' :
                             config.metodo === 'twilio' ? 'Twilio API' : 
                             config.metodo === 'api_oficial' ? 'API Oficial (Meta)' : 
                             config.metodo === 'baileys' ? 'WhatsApp Web' : config.metodo}
                  </p>
                </div>
              </div>
              {isSuperAdmin && (
                <Button variant="outline" onClick={desconectar} className="text-red-500 border-red-300 hover:bg-red-50">
                  <WifiOff className="w-4 h-4 mr-2" /> Desconectar
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Seleção de Método */}
      {config?.status !== 'conectado' && isSuperAdmin && (
        <div className="space-y-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Opção 1: Z-API - RECOMENDADO */}
            <Card className={'cursor-pointer transition-all hover:shadow-lg ' + (config?.metodo === 'zapi' ? 'ring-2 ring-green-500' : 'border-green-200')}>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 flex-wrap">
                  <MessageSquare className="w-6 h-6 text-green-500" />
                  Z-API
                  <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded">Recomendado</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2 text-sm text-slate-600">
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> 100% Brasileiro, suporte em PT-BR</p>
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> Setup em 5 minutos via QR Code</p>
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> Respostas gratuitas (24h)</p>
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> Pagamento em R$</p>
                </div>
                
                <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                  <p className="text-sm text-green-800 font-medium mb-2">📋 Como configurar:</p>
                  <ol className="text-sm text-green-700 space-y-1 list-decimal list-inside">
                    <li>Crie conta em <a href="https://www.z-api.io" target="_blank" rel="noopener noreferrer" className="underline">z-api.io</a></li>
                    <li>Crie uma <strong>instância</strong> e escaneie o QR Code</li>
                    <li>Copie <strong>Instance ID</strong> e <strong>Token</strong></li>
                    <li>Configure o <strong>Webhook</strong> na Z-API</li>
                  </ol>
                </div>
                
                {config?.metodo === 'zapi' && (
                  <div className="space-y-3">
                    <div>
                      <label className="text-sm font-medium">Instance ID *</label>
                      <Input 
                        placeholder="Seu Instance ID"
                        value={zapiInstanceId}
                        onChange={function(e) { setZapiInstanceId(e.target.value); }}
                        data-testid="zapi-instance-id-input"
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">Token *</label>
                      <Input 
                        type="password"
                        placeholder="Seu Token"
                        value={zapiToken}
                        onChange={function(e) { setZapiToken(e.target.value); }}
                        data-testid="zapi-token-input"
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">Security Token (opcional)</label>
                      <Input 
                        type="password"
                        placeholder="Security Token"
                        value={zapiSecurityToken}
                        onChange={function(e) { setZapiSecurityToken(e.target.value); }}
                      />
                    </div>
                  </div>
                )}
                
                <div className="flex gap-2">
                  {config?.metodo !== 'zapi' ? (
                    <Button onClick={function() { selecionarMetodo('zapi'); }} disabled={conectando} className="w-full bg-green-600 hover:bg-green-700">
                      Selecionar Z-API
                    </Button>
                  ) : (
                    <Button onClick={conectarZapi} disabled={conectando} className="w-full bg-green-600 hover:bg-green-700">
                      <Key className="w-4 h-4 mr-2" /> Conectar Z-API
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>

            {/* Opção 2: Twilio */}
            <Card className={'cursor-pointer transition-all hover:shadow-lg ' + (config?.metodo === 'twilio' ? 'ring-2 ring-purple-500' : 'border-purple-200')}>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 flex-wrap">
                  <Phone className="w-6 h-6 text-purple-500" />
                  Twilio API
                  <span className="text-xs bg-purple-100 text-purple-600 px-2 py-1 rounded">Internacional</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2 text-sm text-slate-600">
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> Sandbox gratuito para testes</p>
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> Setup em 5 minutos</p>
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> Não precisa de aprovação</p>
                  <p className="flex items-center gap-2"><AlertCircle className="w-4 h-4 text-yellow-500" /> Pagamento em USD</p>
                </div>
                
                <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
                  <p className="text-sm text-purple-800 font-medium mb-2">📋 Como configurar:</p>
                  <ol className="text-sm text-purple-700 space-y-1 list-decimal list-inside">
                    <li>Crie conta em <a href="https://www.twilio.com/try-twilio" target="_blank" rel="noopener noreferrer" className="underline">twilio.com</a></li>
                    <li>Vá em <strong>Messaging → WhatsApp Sandbox</strong></li>
                    <li>Copie <strong>Account SID</strong> e <strong>Auth Token</strong></li>
                    <li>Use o número do Sandbox</li>
                  </ol>
                </div>
                
                {config?.metodo === 'twilio' && (
                  <div className="space-y-3">
                    <div>
                      <label className="text-sm font-medium">Account SID *</label>
                      <Input 
                        placeholder="ACxxxxxxxxxxxxxxx..."
                        value={twilioAccountSid}
                        onChange={function(e) { setTwilioAccountSid(e.target.value); }}
                        data-testid="twilio-account-sid-input"
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">Auth Token *</label>
                      <Input 
                        type="password"
                        placeholder="Seu Auth Token"
                        value={twilioAuthToken}
                        onChange={function(e) { setTwilioAuthToken(e.target.value); }}
                        data-testid="twilio-auth-token-input"
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">Número WhatsApp Twilio *</label>
                      <Input 
                        placeholder="+14155238886"
                        value={twilioWhatsappNumber}
                        onChange={function(e) { setTwilioWhatsappNumber(e.target.value); }}
                        data-testid="twilio-whatsapp-number-input"
                      />
                      <p className="text-xs text-slate-500 mt-1">Use o número do Sandbox ou seu número aprovado</p>
                    </div>
                  </div>
                )}
                
                <div className="flex gap-2">
                  {config?.metodo !== 'twilio' ? (
                    <Button onClick={function() { selecionarMetodo('twilio'); }} disabled={conectando} className="w-full bg-purple-600 hover:bg-purple-700">
                      Selecionar Twilio
                    </Button>
                  ) : (
                    <Button onClick={conectarTwilio} disabled={conectando} className="w-full bg-purple-600 hover:bg-purple-700">
                      <Key className="w-4 h-4 mr-2" /> Conectar Twilio
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>

            {/* Opção 3: API Oficial Meta */}
            <Card className={'cursor-pointer transition-all hover:shadow-lg ' + (config?.metodo === 'api_oficial' ? 'ring-2 ring-blue-500' : '')}>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 flex-wrap">
                  <Globe className="w-6 h-6 text-blue-500" />
                  API Oficial (Meta)
                  <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded">Produção</span>
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2 text-sm text-slate-600">
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> 100% estável e oficial</p>
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> Suporte oficial da Meta</p>
                  <p className="flex items-center gap-2"><Check className="w-4 h-4 text-green-500" /> 1000 conversas/mês grátis</p>
                  <p className="flex items-center gap-2"><AlertCircle className="w-4 h-4 text-yellow-500" /> Requer aprovação Meta Business</p>
                </div>
                
                <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                  <p className="text-sm text-blue-800 font-medium mb-2">📋 Como configurar:</p>
                  <ol className="text-sm text-blue-700 space-y-1 list-decimal list-inside">
                    <li>Acesse <a href="https://business.facebook.com" target="_blank" rel="noopener noreferrer" className="underline">business.facebook.com</a></li>
                    <li>Crie app em <a href="https://developers.facebook.com/apps" target="_blank" rel="noopener noreferrer" className="underline">developers.facebook.com</a></li>
                    <li>Adicione "WhatsApp" ao app</li>
                    <li>Copie Token e Phone Number ID</li>
                  </ol>
                </div>
                
                {config?.metodo === 'api_oficial' && (
                  <div className="space-y-3">
                    <div>
                      <label className="text-sm font-medium">Access Token *</label>
                      <Input 
                        type="password"
                        placeholder="EAAxxxxxxx..."
                        value={apiToken}
                        onChange={function(e) { setApiToken(e.target.value); }}
                        data-testid="api-token-input"
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">Phone Number ID *</label>
                      <Input 
                        placeholder="123456789..."
                        value={phoneNumberId}
                        onChange={function(e) { setPhoneNumberId(e.target.value); }}
                        data-testid="phone-number-id-input"
                      />
                    </div>
                    <div>
                      <label className="text-sm font-medium">Business Account ID (opcional)</label>
                      <Input 
                        placeholder="123456789..."
                        value={businessAccountId}
                        onChange={function(e) { setBusinessAccountId(e.target.value); }}
                      />
                    </div>
                    {config?.webhook_verify_token && (
                      <div className="p-3 bg-blue-50 rounded-lg text-sm">
                        <p className="font-medium text-blue-800">Webhook configurado:</p>
                        <p className="text-blue-600 text-xs break-all">Token: {config.webhook_verify_token}</p>
                      </div>
                    )}
                  </div>
                )}
                
                <div className="flex gap-2">
                  {config?.metodo !== 'api_oficial' ? (
                    <Button onClick={function() { selecionarMetodo('api_oficial'); }} disabled={conectando} className="w-full bg-blue-600 hover:bg-blue-700">
                      Selecionar API Oficial
                    </Button>
                  ) : (
                    <Button onClick={conectarApiOficial} disabled={conectando} className="w-full bg-blue-600 hover:bg-blue-700">
                      <Key className="w-4 h-4 mr-2" /> Conectar
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      )}

      {/* Teste de Envio */}
      {config?.status === 'conectado' && (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Send className="w-5 h-5 text-green-500" />
              Teste de Envio
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium">Telefone (com DDD)</label>
                <Input 
                  placeholder="5511999999999"
                  value={telefoneTeste}
                  onChange={function(e) { setTelefoneTeste(e.target.value); }}
                  data-testid="telefone-teste-input"
                />
              </div>
              <div>
                <label className="text-sm font-medium">Mensagem</label>
                <Input 
                  placeholder="Digite a mensagem..."
                  value={mensagemTeste}
                  onChange={function(e) { setMensagemTeste(e.target.value); }}
                  data-testid="mensagem-teste-input"
                />
              </div>
            </div>
            <Button onClick={enviarTeste} className="bg-green-600 hover:bg-green-700" data-testid="enviar-teste-btn">
              <Send className="w-4 h-4 mr-2" /> Enviar Mensagem de Teste
            </Button>
          </CardContent>
        </Card>
      )}

      {/* Informações */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-slate-500" />
            Informações Importantes
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-3 gap-6 text-sm text-slate-600">
            <div>
              <h4 className="font-semibold text-green-800 mb-2 flex items-center gap-2">
                <MessageSquare className="w-4 h-4" /> Z-API
              </h4>
              <ul className="space-y-1">
                <li>• 100% Brasileiro, suporte em PT-BR</li>
                <li>• Pagamento em R$</li>
                <li>• Respostas gratuitas (janela 24h)</li>
                <li>• Planos a partir de ~R$50/mês</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-purple-800 mb-2 flex items-center gap-2">
                <Phone className="w-4 h-4" /> Twilio API
              </h4>
              <ul className="space-y-1">
                <li>• Sandbox gratuito para testes</li>
                <li>• Pagamento em USD</li>
                <li>• Custo: ~$0.005/msg</li>
                <li>• Ideal para desenvolvimento</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-blue-800 mb-2 flex items-center gap-2">
                <Globe className="w-4 h-4" /> API Oficial (Meta)
              </h4>
              <ul className="space-y-1">
                <li>• 1000 conversas/mês grátis</li>
                <li>• Requer aprovação da Meta</li>
                <li>• Templates pré-aprovados</li>
                <li>• Ideal para alto volume</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Modal Adicionar/Editar Canal */}
      <Dialog open={modalCanal} onOpenChange={setModalCanal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{editingCanal ? 'Editar Canal' : 'Adicionar Canal Z-API'}</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Nome do Canal *</Label>
              <Input
                value={formCanal.nome}
                onChange={function(e) { setFormCanal({...formCanal, nome: e.target.value}); }}
                placeholder="Ex: Atendimento, Suporte, Vendas"
              />
            </div>
            
            <div className="space-y-2">
              <Label>Instance ID *</Label>
              <Input
                value={formCanal.instance_id}
                onChange={function(e) { setFormCanal({...formCanal, instance_id: e.target.value}); }}
                placeholder="ID da instância Z-API"
              />
            </div>
            
            <div className="space-y-2">
              <Label>Token {editingCanal ? '(deixe vazio para manter)' : '*'}</Label>
              <Input
                type="password"
                value={formCanal.token}
                onChange={function(e) { setFormCanal({...formCanal, token: e.target.value}); }}
                placeholder="Token da instância Z-API"
              />
            </div>
            
            <div className="space-y-2">
              <Label>Security Token (Client-Token)</Label>
              <Input
                type="password"
                value={formCanal.security_token}
                onChange={function(e) { setFormCanal({...formCanal, security_token: e.target.value}); }}
                placeholder="Security token (opcional)"
              />
            </div>
            
            <div className="space-y-2">
              <Label>Descrição</Label>
              <Input
                value={formCanal.descricao}
                onChange={function(e) { setFormCanal({...formCanal, descricao: e.target.value}); }}
                placeholder="Descrição do canal (opcional)"
              />
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={function() { setModalCanal(false); }}>
              Cancelar
            </Button>
            <Button onClick={salvarCanal} disabled={salvandoCanal} className="bg-green-600 hover:bg-green-700">
              {salvandoCanal ? 'Salvando...' : (editingCanal ? 'Atualizar' : 'Adicionar')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
